import React, { useEffect, useReducer, useState } from 'react';
import { useConfig } from '../../DataStore/ConfigContext';
import Notification from '../Common/Notification';
import CallOut from '../Common/CallOut';
import TextInput from '../Common/TextInput';
import ActivityLoader from '../Common/ActivityLoader';
import ajaxConfig from '../../util/remote/ajaxConfig';
import ajaxUser from '../../util/remote/ajaxUser';
import { useStaff } from '../../DataStore/StaffContext';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {...initialState}
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
    username: '',
    loading: false,
}

const StaffAccessConfig = ({teacherId}) => {

    const [currentNotify, setNotify] = useState(null);
    const [state, dispatch] = useReducer(reducer, initialState);
    const { loadProfile } = useStaff();

    useEffect(()=>{
        if(currentNotify){
            setTimeout(() => {
                setNotify(null);
            }, 5000);
        }
    }, [currentNotify]);

    const handleSave = async (event) =>{
        event.preventDefault();
        if(state.loading){
            return;
        }

        if(state.username.length === 0){
            setNotify(<Notification type='danger' message="Enter username & try again"/>);
            return;
        }

        dispatch({type: 'loading', value: true});
        const server_response = await ajaxUser.connectStaff(teacherId, state.username);
        dispatch({type: 'loading', value: false});
        if(server_response.status==="OK"){
            setNotify(<Notification type='success' message={server_response.message}/>);
            dispatch({type: 'username', value: ''});
            /**
             * Refresh data in context after the success notification has showed up to mitigate the re-render effect.
             */
            loadProfile(teacherId);
           
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>);
        }

    }


     
  

    return (
        <div className="card-body">

            <CallOut 
                title="Staff Access"
                description="Connect a staff member to the system by entering their username. This will allow them to access the system and perform their duties. Please ensure that the username exists in the system before connecting.
                In order to disconnect the staff, simply deactivate the staff from the menu."
             />
            {currentNotify}
            <form className="form-horizontal" method="post" onSubmit={handleSave}>

                <TextInput
                    type="text"
                    label="Username"
                    placeholder="Enter Staff eSchool Username"
                    leftIcon="fa fa-user"
                    value={state.username}
                    onChange={e => dispatch({type: 'username', value: e.target.value})}
                    required
                    wrap
                    />

                

                <div className="text-right">
                    {!state.loading && <button type="submit" className="btn btn-lg btn-primary">Connect Staff</button>}
                    {state.loading && <ActivityLoader />}
                </div>

            </form> 


        </div>
    );
};

export default StaffAccessConfig;